import React from 'react';
import { CalendarEventDto } from '@/types/calendar';
import { FoodEventDetails } from './events/food/FoodEventDetails';
import { WorkoutEventDetails } from './events/workout/WorkoutEventDetails';
import { FluidEventDetails } from './events/fluid/FluidEventDetails';
import { MedicationEventDetails } from './events/medication/MedicationEventDetails';
import { FeelingEventDetails } from './events/feeling/FeelingEventDetails';
import { TaskEventDetails } from './events/task/TaskEventDetails';
import { AppointmentEventDetails } from './events/appointment/AppointmentEventDetails';

type DetailsComponent = React.FC<{ event: CalendarEventDto }>;

const detailsMap: Record<string, DetailsComponent> = {
  food: FoodEventDetails,
  workout: WorkoutEventDetails,
  fluid: FluidEventDetails,
  medication: MedicationEventDetails,
  feeling: FeelingEventDetails,
  task: TaskEventDetails,
  appointment: AppointmentEventDetails,
};

interface Props {
  event: CalendarEventDto;
}

export const CalendarEventDetails: React.FC<Props> = ({ event }) => {
  const Component = detailsMap[event.eventType.code];
  if (!Component) return null;
  return <Component event={event} />;
};
